export default "__VITE_ASSET__DBD_eM1D__"